<template>
  <b-modal
    :id="id"
    title="ยืนยันการนำเข้ารายชื่อ"
    centered
    cancel-title="ยกเลิก"
    ok-variant="success"
    :ok-disabled="isSyncing"
    @ok="syncAttendantListFromEvent"
  >
    การนำเข้ารายชื่อจากระบบทรานสคริปกิจกรรมจะไม่ถูกแทนที่หากมีการนำเข้ารายชื่อด้วยไฟล์ Excel ในภายหลัง
    <b-card
      v-if="isSyncing"
      bg-variant="light"
      class="text-center my-2"
    >
      <b-spinner style="width: 3rem; height: 3rem" />
      <div>กำลังดำเนินการ กรุณารอสักครู่</div>
    </b-card>
    <b-card
      v-if="isFinished"
      bg-variant="light"
      text-variant="success"
      class="text-center my-2"
    >
      <font-awesome-icon :icon="['far', 'check-circle']" size="3x" />
      <div>นำเข้าข้อมูลสำเร็จ</div>
    </b-card>
    <template slot="modal-ok">
      นำเข้ารายชื่อ
    </template>
  </b-modal>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    id: { type: String, required: true }
  },
  data () {
    return {
      isSyncing: false,
      isFinished: false
    }
  },
  methods: {
    async syncAttendantListFromEvent (event) {
      event.preventDefault()
      this.isSyncing = true
      await this.$apollo.mutate({
        mutation: gql`mutation($id: ID!) { projectSyncAttendantListFromEvent(id: $id) { participants { studentId, name, type } } }`,
        variables: { id: this.$route.params.id }
      })
      this.isFinished = true
      this.isSyncing = false
    }
  }
}
</script>

<style scoped>

</style>
